// height_equalizer

var height_equalizer = function () {

  $.fn.equalize = function(){
      var maxHeight = 0;
      this.each(function(){
          var $this = $(this);
          if($this.height() > maxHeight){maxHeight = $this.height();}
      });

      return this.each(function(){
          $(this).height(maxHeight);

      });
  };


  var resizeTimer;
  $(window).on('resize', function(e) {

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      // Run code here, resizing has "stopped"
      $('.js-h-equalizer').equalize();
    }, 500);

  });

  $(window).on('load', function(e) {
    //
    $('.js-h-equalizer').equalize();

  });


}
